/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { PasswordResetAttestationData } from './PasswordResetAttestationData';
import {
    PasswordResetAttestationDataFromJSON,
    PasswordResetAttestationDataFromJSONTyped,
    PasswordResetAttestationDataToJSON,
} from './PasswordResetAttestationData';

/**
 * 
 * @export
 * @interface PasswordResetAttestation
 */
export interface PasswordResetAttestation {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordResetAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {PasswordResetAttestationData}
     * @memberof PasswordResetAttestation
     */
    data?: PasswordResetAttestationData;
}

/**
 * Check if a given object implements the PasswordResetAttestation interface.
 */
export function instanceOfPasswordResetAttestation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;

    return isInstance;
}

export function PasswordResetAttestationFromJSON(json: any): PasswordResetAttestation {
    return PasswordResetAttestationFromJSONTyped(json, false);
}

export function PasswordResetAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetAttestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': !exists(json, 'data') ? undefined : PasswordResetAttestationDataFromJSON(json['data']),
    };
}

export function PasswordResetAttestationToJSON(value?: PasswordResetAttestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
        'challenge_type': ChallengeTypeToJSON(value.challenge_type),
        'data': PasswordResetAttestationDataToJSON(value.data),
    };
}

